<template>
  <!-- App更新 -->
  <div class="appMan">
    <!-- 面包屑导航 -->
    <crumbs-bar
      @refresh="handleRefresh"
      :crumbsList="['系统配置', $route.meta.title]"
    >
    </crumbs-bar>
    <!-- 表单容器 -->
    <el-scrollbar
      style="
        height: calc(100% - 60px);
        padding-top: 20px;
        box-sizing: border-box;
      "
    >
      <el-form
        :model="addForm"
        label-position="rigth"
        label-width="100px"
        :rules="addFormRule"
        ref="addForm"
      >
        <div class="form-item-wrap">
          <el-form-item label="商城名称" prop="name">
            {{ $store.state.title }}
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="版本名称" prop="name">
            <el-input
              v-model="addForm.name"
              clearable
              style="width: 200px"
            ></el-input>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="原版本号" prop="oldVersion">
            <el-input
              v-model="addForm.oldVersion"
              clearable
              style="width: 200px"
              type="number"
            ></el-input>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="新版本号" prop="newVersion">
            <el-input
              v-model="addForm.newVersion"
              clearable
              style="width: 200px"
            ></el-input>
          </el-form-item>
          <!-- <el-input
              v-model="addForm.newVersion"
              clearable
              style="width: 200px"
              type="number"
            ></el-input>
          </el-form-item> -->
        </div>
        <div class="form-item-wrap">
          <el-form-item label="强制更新" prop="isForce">
            <el-select
              v-model="addForm.isForce"
              placeholder="是否强制更新"
              style="width: 200px"
            >
              <el-option label="是" value="1"></el-option>
              <el-option label="否" value="0"></el-option>
            </el-select>
            <span style="margin-left: 10px">默认选择强制，IOS始终为强制</span>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="更新文件(apk)" prop="file">
            <upload @fileChange="fallback" :size="10240"></upload>
            <span
              v-show="addForm.file"
              style="margin-left: 10px; color: #67c23a"
            >
              上传成功
              <i class="el-icon-success"></i>
            </span>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="更新说明" prop="des">
            <el-input
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 8 }"
              placeholder="请输入内容"
              class="elInputTextArea_preWrap"
              style="width: 400px"
              v-model="addForm.des"
            >
            </el-input>
          </el-form-item>
        </div>
        <div class="form-item-wrap" style="color: #f56c6c">
          <el-form-item label="" prop="">
            <div>1、APP中更新默认全部都是强制更新，用户不同意就会退出应用</div>
            <div>2、IOS是查询appstore上的版本，不受后台控制</div>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="" prop="">
            <el-button type="primary" @click="submitForm">提交</el-button>
            <el-button type="info" @click="resetForm">重置</el-button>
          </el-form-item>
        </div>
      </el-form>
    </el-scrollbar>
  </div>
</template>

<script>
//混入
import { mustFill } from "@/mixins/data/valid.js"; //混入表单必填项

export default {
  name: "appMan",
  data() {
    return {
      /**新增表单 */
      //版本名称 原版本号 新版本号 强制更新 APK文件 更新说明
      addForm: {
        name: "",
        oldVersion: "",
        newVersion: "",
        isForce: 1,
        file: "",
        des: "",
      },
      /**新增表单规则 */
      addFormRule: {
        name: [mustFill],
        oldVersion: [mustFill],
        newVersion: [mustFill],
        isForce: [mustFill],
        file: [mustFill],
        des: [mustFill],
      },
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      let data = {
        json: JSON.stringify({ type: "AppVersion", Source: "商城" }),
        proc: "Proc_AppPuse",
        type: "ReturnList",
      };
      this.$requestSys({
        url: "qualification/ashx/ReturnJson.ashx",
        method: "post",
        data: data,
      }).then((res) => {
        if (res.flag == 0) {
          this.addForm.name = res.data[0].VersionName;
          this.addForm.oldVersion = res.data[0].VersionNo;
          this.addForm.isForce = res.data[0].ForceUpdate;
          this.addForm.des = res.data[0].UpdateDescription;
        }
      });
    },
    /**重置表单|刷新页面 */
    handleRefresh() {
      this.resetForm();
    },
    submitForm() {
      this.$refs["addForm"].validate((valid) => {
        if (valid) {
          if (parseFloat(this.addForm.newVersion) <= 0) {
            this.$message({
              message: "版本号不能为负数或零！",
              type: "warning",
            });
            return;
          } else if (
            parseFloat(this.addForm.newVersion) <=
            parseFloat(this.addForm.oldVersion)
          ) {
            this.$message({
              message: "新版本号不能比旧版本号低！",
              type: "warning",
            });
            return;
          }
          let data = {
            type: "PC_SetAddApp",
            VersionNo: this.addForm.newVersion,
            UpdateDescription: this.addForm.des,
            ForceUpdate: this.addForm.isForce,
            DownloadAddress: this.addForm.file,
            VersionName: this.addForm.name,
            Source: "商城",
          };
          let proc = "Proc_AppPuse"; //存储过程名
          let type = "ReturnNumber";
          this.$requestSys({
            method: "post",
            url:
              "qualification/ashx/ReturnJson.ashx?type=" +
              type +
              "&json=" +
              encodeURIComponent(JSON.stringify(data)) +
              "&proc=" +
              proc,
          }).then((res) => {
            if (res.flag == 0) {
              this.$message({
                message: "更新成功",
                type: "success",
              });
              this.resetForm();
            } else {
              this.$message({
                message: res.message,
                type: "warning",
              });
            }
          });
        } else {
          this.$message({
            message: "请补全信息",
            type: "warning",
          });
        }
      });
    },
    /**重置表单 */
    resetForm() {
      this.$refs["addForm"].resetFields();
      this.getData();
    },
    /**文件上传回调 */
    fallback(file) {
      let type = "APK";
      let fileData = new FormData();
      for (let i = 0; i < file.length; i++) {
        fileData.append("ShopAPKFile", file[i]);
      }
      this.$uploadRequest({
        method: "post",
        url:
          "admin/ashx/UploadImg.ashx?type=UploadApk&apptype=" +
          type +
          "&source=商城",
        data: fileData,
        timeout: 1000000,
      })
        .then((res) => {
          if (res.flag == 0) {
            this.addForm.file = res.message;
            this.$message({
              message: "上传成功",
              type: "success",
            });
          } else {
            this.$message({
              message: res.message,
              type: "warning",
            });
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style scoped>
.appMan {
  width: 100%;
  height: 100%;
}
</style>
